<template>
  <div>
    <Head title="Create Country" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/country">Countries</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
            <text-input v-model="form.country_code" :error="form.errors.country_code" class="pb-8 pr-6 w-full lg:w-1/2" label="Country code" />
            <text-input v-model="form.number_prefix" :error="form.errors.country_code" class="pb-8 pr-6 w-full lg:w-1/2" label="Phone number prefix" />
            <select-input v-model="form.language_code" :error="form.errors.language_code"  class="pb-8 pr-6 w-full lg:w-1/2" label="Language">
                <option value="en">EN</option>
                <option value="de">DE</option>
            </select-input>
            <select-input v-model="form.is_enabled" :error="form.errors.language_code"  class="pb-8 pr-6 w-full lg:w-1/2" label="Is enabled">
                <option value="1">Yes</option>
                <option value="0">No</option>
            </select-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Country</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import throttle from 'lodash/throttle'
import axios from 'axios'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput
  },
  layout: Layout,
  remember: 'form',
    props: {
        tags: Array
    },
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        country_code: '',
        number_prefix: '',
        language_code: 'en',
        is_enabled: true
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/country')
    },
  },
}
</script>
